import { Invoice } from '../../types/domain';

export interface AccountViewProps {
  section?: 'general' | 'security' | 'billing' | 'organizations';
}

export type AccountTabKey = 'general' | 'security' | 'billing' | 'organizations';
export type BillingSubTabKey = 'subscriptions' | 'billing';

export const formatBillingDate = (d?: string | null): string => {
  if (!d) return '—';
  try {
    const date = new Date(d);
    if (isNaN(date.getTime())) return '—';
    return date.toLocaleDateString(undefined, {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });
  } catch {
    return '—';
  }
};

export const formatCurrency = (cents: number, currency: string = 'USD'): string => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: (currency || 'USD').toUpperCase(),
  }).format((cents || 0) / 100);
};
